module.exports = __webpack_public_path__ + "static/media/act2.350a9f35.jpg";